var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "align-end" },
    [
      _vm.socketMessage.length > 4
        ? _c(
            "v-btn",
            {
              staticClass: "button-border view-all-button",
              attrs: { tile: "", text: _vm.viewAll, block: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("viewAll", $event)
                }
              }
            },
            [
              _c("span", { staticClass: "subtitle-2" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.viewAll ? _vm.$t("Hide") : _vm.$t("ViewAll")) +
                    "\n    "
                )
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55ce1096", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55ce1096","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Management/Notifications/_Atoms/ViewAllButton.vue
// module id = null
// module chunks = 